import React from 'react';
import { Navigate, useParams } from 'react-router';
import { ContainerLayout } from 'components/index';
import { useNavigate } from 'features/cobrand/hooks/useCobrandUtils';
import { useLoggedInUser } from 'features/auth/hooks/useAuthData';
import { BiometricType } from 'services/biometricsService';
import { useBiometricDownload } from 'hooks/useBiometricDownload';
import { BloodSugarDetailPage } from 'components/ProgressTab/BloodSugarDetail/BloodSugarDetailPage';

type WidgetDetailPageProps = React.ComponentProps<typeof BloodSugarDetailPage>;

// One route (`/progress/:widget`) for every widget detail page. Each page fetches its own data and
// owns its loading/error/empty states; add the next widget here.
const WIDGET_DETAILS: Record<
  string,
  { biometricType: BiometricType; Page: React.ComponentType<WidgetDetailPageProps> }
> = {
  'blood-sugar': { biometricType: 'blood_glucose', Page: BloodSugarDetailPage },
};

const WidgetDetailContent = ({ widget }: { widget: string }) => {
  const navigate = useNavigate();
  const user = useLoggedInUser();
  const { biometricType, Page } = WIDGET_DETAILS[widget];
  const { download, isDownloading } = useBiometricDownload(biometricType, user?.id ?? 0);

  return (
    <ContainerLayout>
      <Page
        onBack={() => navigate('/progress')}
        onDownload={download}
        isDownloading={isDownloading}
      />
    </ContainerLayout>
  );
};

export const WidgetDetail = () => {
  const { widget = '' } = useParams();

  return widget in WIDGET_DETAILS ? (
    <WidgetDetailContent key={widget} widget={widget} />
  ) : (
    <Navigate to="/progress" replace />
  );
};
